import { Inject, Injectable } from '@angular/core';
import { Auth } from '../../auth/auth.service';

@Injectable()
export class UserInactivity {
  private readonly INACTIVITY_ERR_MESSAGE = "You've been logged out due to inactivity.";
  constructor(
    @Inject('Idle') private idle,
    @Inject('Title') private title,
    @Inject('$rootScope') private $rootScope,
    @Inject('$location') private $location,
    private auth: Auth,
  ) {
    // user gets logged out 15 mins of inactivity (ng-idle) (CM)
    this.$rootScope.$on('IdleTimeout', () => {
      const lastKnownUrl = this.$location.url();
      const logoutOpts = { errorMessage: this.INACTIVITY_ERR_MESSAGE, lastKnownUrl };

      // log user out of the app after 15 min of inactivity (CM)
      this.auth.logout(logoutOpts);
    });
  }

  /**
   * Watch for idleness from the user
   * The user will get logged out after 15 min of inactivity (CM)
   */
  start() {
    this.idle.watch();

    if (this.auth.isAuthenticated()) {
      this.title.restore(); // clear tab title (CM)
    } else {
      this.auth.logout();
    }
  }
}
